module.exports = __webpack_public_path__ + "img/hexa.5c654583.svg";